import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogContent,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
  Paper,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import React, { useEffect } from "react";
import { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import AgGridTable from "../utilities/AgGridTable";
import { useRef } from "react";
import moment from "moment";
import Draggable from 'react-draggable';
import jwtDecode from "jwt-decode";
import { hasShowroom } from "../utilities/showroomUtils";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material"; 
const useStyles = makeStyles((theme) => ({
  root: {
    "& .order-detail-summary": {
      flexDirection: "row",
      display: "flex",
      flexWrap: "wrap",
      padding: 0,

      "& li": {
        padding: "5px 0",
        width: "50%",
        display: "flex",
        alignItems: "center",

        "& label": {
          display: "inline-block",
          width: "167px",
        },

        [theme.breakpoints.down("md")]: {
          width: "100%",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: "8px 0",

          "& label": {
            width: "100%",
            marginBottom: 4,
            fontWeight: 500,
          },
          "& > div": {
            width: "100%",
            paddingRight: "0 !important",   // overrides the pr-24 class
          },
        },
      },
    },
  },
}));
function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"], button'}  
      disabled={isMobile}                                  
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}
export default function ViewContainer(props) {
  const classes = useStyles(props);
  const gridRef = useRef();
  const perPage = 20;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { open, onClose, selectedContainer, filteredLoadingWeek, data, hasPartner, hasPartnerOrderProRole, hasPartnerShwMngrRole, hasSuperRole, lacqueredRanges } = props;
  const [orderList, setOrderList] = useState([]);
  // const result = data.find((item) => item.id === selectedContainer?.id);
  const [gridParams, setGridParams] = useState(null);
  const [currentWeek, setCurrentWeek] = useState('')
  const [currentYears, setCurrentYears] = useState('')
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));
  const handleDateFormat = (props) => {
    return props.value && moment(props.value).format('DD-MM-YYYY')
  }
   const showDiscountPercentMoney = (props) => {
    const formattedValue = new Intl.NumberFormat("en-GB", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(props.value || 0);

    return (
      <p style={{ textAlign: "right", margin: 0 }}>{`${formattedValue}`}</p>
    );
  };
  const specialDiscountIcon = (params) => {
    const data = params?.data;
    if (!data) return null;

    const { commissionName, specialDiscountRequested, sdrStatus } = data;

    return (
      <span
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {commissionName}
        {sdrStatus === "APPROVED" ? (
          <FuseSvgIcon
            size={18}
            sx={{ color: theme.palette.success.main }}
          >
            heroicons-solid:tag
          </FuseSvgIcon>
        ) : sdrStatus === "WAITING" || sdrStatus === "PENDING" ? (
          <FuseSvgIcon
            size={18}
            sx={{ color: theme.palette.error.main }}
          >
            heroicons-solid:tag
          </FuseSvgIcon>
        ) : (
          ""
        )}
      </span>
    );
  };
  const showFixedValue = (props) => {
    let formattedNumbers;
    if (Number.isNaN(props?.value) || props?.value === 0 || !props?.value) {
      formattedNumbers = "";
    } else {
      if (props.colDef.field === "volume" || props.colDef.field === "weight") {
        formattedNumbers = new Intl.NumberFormat("en-US", {
          maximumFractionDigits: 3,
          minimumFractionDigits: 3,
        }).format(props?.value);
      } else {
        formattedNumbers = new Intl.NumberFormat("en-US", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }).format(props?.value);
      }
    }
    return <p>{`${formattedNumbers}`}</p>;
  };
  const getColumnDefs = (orderStatus) => {
    const baseColumns = [
      {
        headerName: "Sr No.",
        minWidth: 60,
        valueGetter: "node.rowIndex + 1",
      },
      {
        field: "abNumber",
        headerName: "AB Number",
        // width: 90,
      },
      {
        field: "commissionName",
        headerName: "Commission Name",
        cellRenderer: specialDiscountIcon,
        minWidth: 300,
      },
      {
        field: "vendorShortKey",
        headerName: "Product",
        minWidth: 60,
      },
      {
        field: "orderCategory",
        headerName: "Category",
        minWidth: 60,
      },
      {
        headerName: "Lacquered",
        minWidth: 60,
        valueGetter: (params) => {
          const { range1Id, range2Id, range3Id } = params.data || {};
          const lacqueredRanges = params.context?.lacqueredRanges || [];

          const isLacquered = [range1Id, range2Id, range3Id].some(
            (id) => id && lacqueredRanges.includes(id),
          );

          return isLacquered ? "Lacquered" : "";
        },
        //  filter: "agTextColumnFilter",
        //  filterParams: {
        //    filterOptions: ["contains"],
        //    defaultOption: "contains",
        //  },
      },
      {
        field: "plannedLoadingWeek",
        headerName: "Loading Week",
        minWidth: 60,
        filterParams: {
          filters: [
            {
              filter: "agNumberColumnFilter",
              filterParams: { buttons: ["clear"] },
            },
            {
              filter: "agSetColumnFilter",
              filterParams: {
                defaultToNothingSelected: true,
                buttons: ["clear"],
              },
            },
          ],
        },
        // enableRowGroup: true,
        // minWidth: 70,
      },
      {
        headerName: "Region / Zone",
        field: "region",
        minWidth: 60,
      },
      {
        field: "volume",
        cellRenderer: showFixedValue,
        minWidth: 60,
        filterParams: {
          filters: [
            {
              filter: "agNumberColumnFilter",
              filterParams: { buttons: ["clear"] },
            },
            {
              filter: "agSetColumnFilter",
              filterParams: {
                defaultToNothingSelected: true,
                buttons: ["clear"],
              },
            },
          ],
        },
        // width: 100
      },
      {
        field: "orderStatus",
        minWidth: 60,
        // width: 150
      },
      {
        field: "orderConfirmedDate",
        cellRenderer: handleDateFormat,
        minWidth: 60,
      },
      {
        field: "cutoffDate",
        cellRenderer: handleDateFormat,
        minWidth: 60,
        hide: !hasSuperRole,
      },
      {
        headerName: "Receivable",
        field: "grandTotal",
        minWidth: 60,
        cellRenderer: showDiscountPercentMoney,
        hide: !hasSuperRole,
      },
    ];

    if (
      !(
        orderStatus === "CLOSE" ||
        orderStatus === "OPEN" ||
        orderStatus === "BOOKING_REQUEST_SENT_TO_NFZE"
      )
    ) {
      baseColumns.push(
        {
          headerName: "Actual Container No",
          field: "actualContainerNo",
           minWidth: 60,
        },
        {
          headerName: "Actual Loading Date",
          field: "actualLoadingDate",
           minWidth: 60,
          cellRenderer: handleDateFormat,
        },
        {
          headerName: "Tour No",
          field: "tourNo",
           minWidth: 60,
        }
      );
    }

    return baseColumns;
  };
  const [containerColumnDefs, setContainerColumnDefs] = useState(
    getColumnDefs(selectedContainer?.containerStatus)
  );

  useEffect(() => {
    setContainerColumnDefs(getColumnDefs(selectedContainer?.containerStatus));
  }, [selectedContainer?.containerStatus]);

  const onRowDoubleClicked = (params) => {
    const id = params.data?.id;
    if (hasPartner && id) {
      if (token?.company === params?.data?.customerNum) {
        window.open(`/order/order-details/${id}`, '_blank');
      }
    } else if (hasPartnerOrderProRole && id) {
      if (token?.email === params?.data?.createdByUser) {
        window.open(`/order/order-details/${id}`, '_blank');
      }
    } else if (hasPartnerShwMngrRole && id) {
      if (hasShowroom(token?.showroom, params?.data?.showroomNum)) {
        window.open(`/order/order-details/${id}`, '_blank');
      }
    } else if (hasSuperRole && id) {
      window.open(`/order/order-details/${id}`, '_blank');
    }
  };
  const products = [
    ...new Set(selectedContainer?.orders ? selectedContainer?.orders.map((order) => order?.vendorShortKey) : null),
  ];

  const totalVolume = selectedContainer?.orders ? selectedContainer?.orders.reduce((a, b) => a + Number(b.volume), 0) : 0;

  const getLoadingWeekList = async () => {
    const vendorIds = selectedContainer?.orders.map(obj => obj.vendorNum);
    // console.log('vendorIds', vendorIds)
    let filterWeek;
    if (vendorIds.length > 0) {
      const filteredData = filteredLoadingWeek.filter(item => vendorIds.includes(item.vendorId));
      filterWeek = filteredData.filter(item => {
        const lastWord = item.kitchenName.split(' ').slice(-2).join(" ");
        return lastWord === 'Kitchen Lacquered' || lastWord === 'Eco Lacquered' || lastWord === 'Spa Lacquered' || lastWord === 'Neo Lacquered' || lastWord === 'Kitchen (SystemLine)';
      });
    } else {
      filterWeek = filteredLoadingWeek.filter(item => {
        const lastWord = item.kitchenName.split(' ').slice(-2).join(" ");
        return lastWord === 'Non Lacquered' || lastWord === '(Normal Handle)';
      });
    }
    const highestWeekObject = filterWeek?.reduce((prev, current) => {
      if (current.year > prev.year) return current;
      if (current.year === prev.year && current.week > prev.week) return current;
      return prev;
    });
    let defaultWeek = highestWeekObject.week;
    let currentYears = highestWeekObject?.year;
    setCurrentWeek(defaultWeek);
    setCurrentYears(currentYears)
  };

  useEffect(() => {
    if (open) {
      getLoadingWeekList();
    }
  }, [open]);
  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="xl"
        fullScreen={isMobile}
        className={clsx(classes.root)}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <AppBar
          position="static"
          color="secondary"
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Container {selectedContainer?.containerNo}
            </Typography>
            <IconButton onClick={onClose} color="inherit">
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
          <Box>
            <ul className="order-detail-summary">
              <li>
                <label>Expected Loading Week</label>
                <div>
                  {selectedContainer?.plannedLoadingWeek}/
                  {
                    selectedContainer?.plannedLoadingYear
                  }
                </div>
              </li>
              {/* <li>
                <label>Expected Loading Week</label>
                <div>
                  {selectedContainer?.plannedLoadingWeek}/
                  {new Date(
                    selectedContainer?.plannedLoadingDate
                  ).getFullYear()}
                </div>
              </li> */}
              <li>
                <label>Container Type</label>
                <div>{selectedContainer?.actualContainerType?.uniqueCode}</div>
              </li>
              <li>
                <label>Cut off date: </label>
                <div>
                  {selectedContainer?.cutOffDate
                    ? moment(selectedContainer.cutOffDate).format("DD-MM-YYYY")
                    : "-"}
                </div>
              </li>
              <li>
                <label>Destination / Region</label>
                <div>{selectedContainer?.destination}</div>
              </li>
              <li>
                <label>Total Nr. Orders</label>
                <div>
                  {selectedContainer?.orders
                    ? selectedContainer?.orders.length
                    : 0}
                </div>
              </li>
              <li>
                <label>Total Volume</label>
                <div>{parseFloat(totalVolume).toFixed(3) || "0"}</div>
              </li>
              <li>
                <label>Products</label>
                <div>{products.join(", ")}</div>
              </li>
              <li>
                <label>Forwarder </label>
                <div>{selectedContainer?.forwarderInfo?.name}</div>
              </li>
              <li>
                <label>Comment</label>
                <div>{selectedContainer?.comment}</div>
              </li>
              {selectedContainer?.actualContainerNumber && (
                <li>
                  <label>Actual Container No</label>
                  <div>{selectedContainer?.actualContainerNumber}</div>
                </li>
              )}
              {selectedContainer?.tourNo && (
                <li>
                  <label>Tour No</label>
                  <div>{selectedContainer?.tourNo}</div>
                </li>
              )}
              {selectedContainer?.actualLoadingDate && (
                <li>
                  <label>Actual Loading Date</label>
                  <div>
                    {moment(selectedContainer?.actualLoadingDate).format(
                      "DD-MM-YYYY",
                    )}
                  </div>
                </li>
              )}
              {selectedContainer?.actualLoadingWeek && (
                <li>
                  <label>Actual Loading Week</label>
                  <div>
                    {selectedContainer?.actualLoadingWeek}/
                    {new Date(
                      selectedContainer?.actualLoadingDate,
                    ).getFullYear()}
                  </div>
                </li>
              )}
            </ul>
          </Box>
          <div className="mt-16" style={{ height: 400 }}>
            <AgGridTable
              rowData={selectedContainer?.orders}
              context={{ lacqueredRanges }}
              columnDefs={containerColumnDefs}
              onRowDoubleClicked={onRowDoubleClicked}
              // onGridReady={onGridReady}
              gridRef={gridRef}
              paginationPageSize={perPage}
              cacheBlockSize={perPage}
              rowGroupPanelShow="never"
            />
          </div>
          <Box
            className="text-right"
            sx={{
              fontSize: 13,
              padding: "5px 10px",
              background: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              borderTop: "none",
            }}
          >
            Total Volume:{" "}
            <strong>{parseFloat(totalVolume).toFixed(3) || "0"}</strong>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
